export * from '@primeuix/themes/nora/tabview';
export { default } from '@primeuix/themes/nora/tabview';
